import * as Sentry from '@sentry/react';

// DSN-guarded: with no VITE_SENTRY_DSN set (dev, PR previews, local) this is a
// no-op — Sentry.init is skipped and every capture becomes a silent noop, so
// nothing breaks and no events are sent. Set VITE_SENTRY_DSN in prod to enable.
const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;

if (dsn) {
  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    integrations: [Sentry.browserTracingIntegration()],
    // Sample 10% of transactions for perf tracing; errors are always captured.
    tracesSampleRate: 0.1,
  });
}

export { Sentry };
